import { all } from 'redux-saga/effects';
import { watchList } from './list';
import watchPull from './pull';
import watchRead from './read';
import watchCounts from './count';

export function* watchNotifications() {
  yield all([watchList(), watchPull(), watchRead(), watchCounts()]);
}
